const selectors = {
  form: '.jobs__filters',
  selects: '.jobs-select',
  selectHead: '.jobs-select__head',
  selectInputs: '.jobs-select__input',
  tags: '.jobs__tag',

  content: '.jobs__content',
}

const classes = {
  activeSelect: 'jobs-select_active',
}

const elements = {
  form: null,
  selects: null,
  tags: null,

  content: null,
}

const Jobs = () => {
  elements.form = document.querySelector(selectors.form);
  elements.selects = document.querySelectorAll(selectors.selects);
  elements.tags = document.querySelectorAll(selectors.tags);
  elements.content = document.querySelector(selectors.content);

  const makeRequest = (url) => {
    return fetch(url, {
      method: "get",
    }).then((response) => {
      response.text().then((response) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response, "text/html");

        elements.content.innerHTML = doc.querySelector(selectors.content).innerHTML;

        removeTagListeners(elements.tags);
        elements.tags = elements.content.querySelectorAll(selectors.tags);
        addTagListeners(elements.tags);

        window.history.pushState({}, "", url);
      });

      return response;
    });
  };

  const submitForm = (e) => {
    e.preventDefault()

    const data = new FormData(elements.form);
    const queryString = new URLSearchParams(data).toString();
    makeRequest("?" + queryString).then(() => {
      console.log("filtered");
    });
  }

  const addTagListeners = tags => {
    console.log('addTagListeners');
    Array.from(tags).map(tag => tag.addEventListener('click', tagListener));
  }

  const removeTagListeners = tags => {
    console.log('removeTagListeners');
    Array.from(tags).map(tag => tag.removeEventListener('click', tagListener));
  }

  const tagListener = (e) => {
    console.log('tagListener');
    const input = document.querySelector(`#${e.currentTarget.dataset.slug}`);
    input.click();
  }

  if (elements.form) {
    Array.from(elements.selects).map(select => {
      const head = select.querySelector(selectors.selectHead);
      const inputs = select.querySelectorAll(selectors.selectInputs);

      head.addEventListener('click', () => select.classList.toggle(classes.activeSelect))

      window.addEventListener('click', function (e) {
        if (!select.contains(e.target)) {
          select.classList.remove(classes.activeSelect)
        }
      });
    })

    elements.form.addEventListener('change', submitForm);
    addTagListeners(elements.tags);
  }

}

export default Jobs;
